<template>
  <div>
    <!-- loading -->
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
  }
})
</script>
